import React, { CSSProperties, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import Game from "../shell/Game";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { selectAdvance } from "../store/slices/AdvanceSlice";
import { selectGameObject } from "../store/slices/gameObjectSlice";
import { GameNames } from '../store/slices/GameTypes';
import { RootState, store } from '../store/store';


export const useSkippingLogic = () => {
    const advanceState = store.getState().advance;
    const { seenWords } = store.getState().advance;
    const { currentScene } = store.getState().gameObject.present;
    const nextAction = Game.Action?.next;

    if (!nextAction) {
        return false;
    }


    if (advanceState.skipping && !Game.rollback) {
        if (nextAction.actionId !== GameNames.TALK) {
            return true;
        }
        if (useIsInSeenWords()) {
            return true;
        }
    }
    return false;

};
export const useIsInSeenWords = () => {
    const { seenWords } = store.getState().advance;
    const { currentScene } = store.getState().gameObject.present;
    const { settings } = store.getState().menu;
    const nextAction = Game.Action?.next;
    if (settings.skipUnseenText) { return true; }

    if (nextAction?.data?.character?.name && nextAction?.data?.text) {
        if (seenWords?.[currentScene + ' ' + nextAction?.data.character.key + ' ' + nextAction.data.text]) {
            return true;
        }
    }
    return false;
};
